import { useState } from 'react';
import { useAccordionButton } from 'react-bootstrap/AccordionButton';

export const CustomToggle = ({ children, eventKey }) => {
  const [isOpen, setIsOpen] = useState(false);
  const decoratedOnClick = useAccordionButton(eventKey, () => {
    setIsOpen((prev) => !prev);
  });

  return (
    <button type="button" className="accordian_btn" onClick={decoratedOnClick}>
      {children}
      {isOpen ? <i className="bi bi-chevron-up"></i> : <i className="bi bi-chevron-down"></i>}
    </button>
  );
};
